<template>
  <div class="order-table-item-summary">
    <div class="order-table-item-summary__link">
      <button
        v-if="hasSummaryText"
        :class="containerClasses"
        class="order-table-item-summary__btn btn btn--text"
        @click="show = !show"
      >
        Alle Details
        <Arrow
          :direction="show ? 'top' : 'bottom'"
          class="order-table-item-summary__icon"
          tag="span"
        />
      </button>
      <nuxt-link
        v-else
        :to="`/geraete/${slug}`"
        class="order-table-item-summary__btn link"
      >
        Produktdetails
      </nuxt-link>
      <transition name="order-table-item-summary__slide-fade-">
        <ul
          v-if="show"
          class="order-table-item-summary__list"
        >
          <li
            v-for="(text, i) in summaryTexts"
            :key="i"
            class="order-table-item-summary__item"
          >
            {{ text }}
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import { Arrow } from '@i22-td-smarthome/component-library';

export default {
  name: 'OrderTableItemSummary',
  components: {
    Arrow,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    summaryTexts: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    containerClasses() {
      const classes = [];
      if (this.show) classes.push('order-table-item-summary__btn--is-active');
      return classes;
    },
    hasSummaryText() {
      return this.summaryTexts.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-table-item-summary {
  &__btn {
    @include font-size(15px, 14px);
  }

  &__icon {
    top: 2px;
    left: 5px;
    position: relative;
    float: right;
    width: 0.7em;
    height: 0.5em;
    color: currentColor;
  }

  &__item {
    @include font-size(15px, 19px);
    padding-bottom: 5px;
    list-style: none;
    padding-left: 14px;
    position: relative;

    &::before {
      content: '';
      width: 5px;
      height: 1px;
      background-color: var(--color-font);
      position: absolute;
      display: inline-block;
      top: 9px;
      left: 0;
    }
  }

  /* Enter and leave animations */
  &__slide-fade {
    &--enter-active {
      transition: all 500ms ease-in;
    }

    &--leave-active {
      transition: all 500ms ease-out;
    }

    &--enter,
    &--leave-to
      /* .slide-fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  }
}
</style>
